class AxeptioTriggerCookies extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    var self = this;
    window._axcb = window._axcb || [];
    window._axcb.push(function(sdk){
      sdk.on('ready', function(){
        self.init();
      });
    });
  }

  init() {
    hideAxeptioButton();

    this.addEventListener('click', (event) => {
      showAxeptioButton();
      openAxeptioCookies();
    })

  }
}

customElements.get('axeptio-trigger-cookies') || customElements.define('axeptio-trigger-cookies', AxeptioTriggerCookies);

